import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import {CustomerOrders} from "../Entity/Order";

export async function getCustomerOrdersRep(token: string): Promise<CustomerOrders[]> {
  try {
    const responseGetCart = await axios.get<CustomerOrders[]>(
      `${BASE_API_URL}/orders`,
      {headers: {Authorization: 'Bearer ' + token}}
    );
    return responseGetCart.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}
